import BurgerMenu from './BurgerMenu';
import BurgerMenuContainer from './BurgerMenu.container';
export default BurgerMenuContainer(BurgerMenu);
//# sourceMappingURL=index.js.map